import $ from 'jquery'
import _ from 'underscore'
import HandlebarsHelper from 'assets/js/handlebarsHelper.js'
import contactFormTemplate from './templates/contact.hbs'
import contactConfirmTemplate from './templates/contactConfirm.hbs'

export default postFormData => {
  HandlebarsHelper()
  let contactTemplate = contactFormTemplate()
  $('#contact').append(contactTemplate)

  $(document).on('click', '#resetButton', function () {
    $('#contact').find('input, textarea, :text, radio, select').val('').end().find(':checked').prop('checked', false)
    $('.-error').removeClass('-error')
    $('.p-contact__main-alert').remove()
    $(this).removeClass('hover')
    scrollToForm()
  })
  $(document).on('click', '#backButton', function () {
    $('#contact__confirm-wrap').hide()
    $('#contact-wrap').show()
    $('.-error').removeClass('-error')
    $('.p-contact__main-alert').remove()
    $('#contact .p-contact.confirm').remove()
    window.scrollTo(0, 0)
  })
  $(document).on('click', '#agree', function () {
    return $(this).prop('checked') ? $('#postButton').prop('disabled', false) : $('#postButton').prop('disabled', true)
  })

  $(document).on('click', '#confirmButton', function () {
    let formData = $('form').serializeArray()
    formData.push({ name: 'validate', value: 1 })
    let jsonData = parseJson(formData)
    entryPost(formData, jsonData)
  })

  $(document).on('click', '#postButton', function () {
    let formData = $('form').serializeArray()
    let jsonData = parseJson(formData)
    entryPost(formData, jsonData)
  })

  let entryPost = (formData, jsonData) => {
    $.ajax({
      type: 'post',
      url: '/contact/api/api.cgi',
      data: formData,
      dataType: 'json',
      contentType: 'application/x-www-form-urlencoded',
      beforeSend: function () {
        $('#confirmButton, #postButton').attr('disabled', 'true')
      }
    }).done(function (response) {
      let isConfirm = true
      _.each(formData, (value, key) => {
        return value.name === 'validate' ? (isConfirm = true) : (isConfirm = false)
      })
      if (isConfirm) {
        if (response.result === 'failed') {
          let errorData = response.validation_errors
          let contactTemplate = contactFormTemplate({
            error: errorData,
            data: jsonData
          })
          $('#contact').empty().append(contactTemplate)
          scrollToAlert()
        } else {
          let confirmTemplate = contactConfirmTemplate({
            jsonData: jsonData,
            formData: formData
          })
          $('#contact-wrap').hide()
          $('#contact__confirm-wrap').show()
          $('#confirm').empty().append(confirmTemplate)
          window.scrollTo(0, 0)
        }
      } else {
        if (response.result === 'failed') {
          let errorData = response.validation_errors
          let contactTemplate = contactFormTemplate({
            error: errorData,
            data: jsonData
          })
          $('#contact__confirm-wrap').hide()
          $('#contact-wrap').show()
          $('#contact').empty().append(contactTemplate)
          scrollToAlert()
        } else {
          $('#contact-wrap, #contact__confirm-wrap').hide()
          $('#contact__complete-wrap').show()
          window.scrollTo(0, 0)
        }
      }
      $('#confirmButton').removeAttr('disabled', 'false')
    }).fail(function (response) {
      console.log('error')
      console.log(response)
    })
  }

  let scrollToAlert = () => {
    let target = $('.p-contact__main-alert').offset()
    window.scrollTo(0, target.top)
  }
  let scrollToForm = () => {
    let target = $('.p-contact__main').offset()
    $('html, body').animate({scrollTop: target.top}, 300, 'swing')
  }

  let parseJson = function (data) {
    var returnJson = {}
    for (let i = 0; i < data.length; i++) {
      returnJson[data[i].name] = data[i].value
    }
    return returnJson
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/postContactForm.js